<template>
  <section>
    <div class="page">
      <div>
        <h2>
          Being blocked by someone
        </h2>
        <h3>
          Blocking contacts
        </h3>
        <p>
          You can stop receiving messages or calls from certain contacts by
          blocking them. In the latest version of ToTok, you block or unblock
          your contact easily by following the steps below.
        </p>
        <p>
          To block a contact:
        </p>
        <ol>
          <li>
            In ToTok, tap Friends, search for or select the contact you want to
            block, tap “...”> <strong>Block</strong>.
          </li>
          <li>Tap <strong>Confirm</strong>.</li>
        </ol>
        <p>
          Note:
        </p>
        <ul>
          <li>
            Messages, calls and status updates sent by a blocked contact won't
            show up on your phone and will never be delivered to you.
          </li>
          <li>
            Blocking a contact won't remove them from your contacts list, nor
            will it remove you from the list on the contact's phone. To delete a
            contact, you must delete the contact from your phone's address book.
          </li>
        </ul>
        <h3>
          Unblocking contacts
        </h3>
        <p>
          To unblock a contact:
        </p>
        <ol>
          <li>
            In ToTok, tap <strong>Me</strong> > <strong>Privacy</strong> >
            <strong>Block List</strong>.
          </li>
          <li>
            Tap the contact you want to unblock.
          </li>
          <li>
            Tap “...” > <strong>Unblock</strong>. You and the contact will now
            be able to send and receive messages, calls and status updates.
          </li>
        </ol>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
